import axiosInterceptor from '../helpers/axiosInterceptor';
import { GET_LAYOUT_TYPES} from "../Constants";

function getLayouts() {
    return axiosInterceptor.get(GET_LAYOUT_TYPES);
}

export { getLayouts };